import { useEffect, useState, useContext } from 'react';
import { downloadCyprusStatisticsReport, fetchCyprusStatisticsReports } from 'services/complianceReportsServices';
import AuthContext from "contexte/AuthContext"
import { useTranslation } from 'react-i18next';
import DashboardLayout from 'components/layout/dashboard/DashboardLayout'
import Notification from 'components/notifications/Notification';
import { launchError } from 'components/notifications';
import DownloaderLink from 'components/DownloaderLink/DownloaderLink';
import './cyprusStatistics.css'

const CyprusStatistics = () => {

  const { user } = useContext(AuthContext);
  const { t } = useTranslation();
  const [files, setFiles] = useState([]);

  useEffect(() => {
    const fetchReportList = async () => {
      try {
        const data = await fetchCyprusStatisticsReports(user);
        setFiles(data);
      } catch (error) {
        launchError(t('notifications.reports.compliance.list.error'))
      }
    }

    fetchReportList();
  }, [])

  return (
    <DashboardLayout page={t(`pages_name.report_compliance_cyprus_statistics`)}>
      <Notification />
      <div className='cyprus_statistics_title_component'>
        <h2>{t(`pages.cyprus_statistics.title`)}</h2>
        {/* <FilterComponent
          date={true}
          selectedDate={selectedDate}
          setSelectedDate={setSelectedDate}
          maxDate={yesterday}
        /> */}
      </div>
      <div>
        <ul>
          {files.map(file => (
            <DownloaderLink
              filename={`cyprus_statistics_${file}.xlsx`}
              fetchData={downloadCyprusStatisticsReport}
              fetchDataParams={{ user, fileName: file }}
              type={'excel'}
              display={file}
              key={file}
            />
          ))}
        </ul>
      </div>
    </DashboardLayout>
  )
}

export default CyprusStatistics;